(() => {
  'use strict';
  document.querySelectorAll('[data-dama-hero-video]').forEach(video => {
    const button = video.parentElement.querySelector('[data-dama-hero-toggle]');
    if (!button) return;
    const audioButton = video.parentElement.querySelector('[data-dama-hero-audio]');
    const mobile = matchMedia('(max-width: 749px)');
    let loaded = false;
    let userPaused = false;
    const sync = () => {
      button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
      audioButton?.setAttribute('aria-label', video.muted ? audioButton.dataset.unmuteLabel : audioButton.dataset.muteLabel);
      audioButton?.setAttribute('aria-pressed', String(!video.muted));
    };
    const play = (automatic = false) => {
      if (!mobile.matches) return;
      if (!loaded) {
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.load();
        loaded = true;
      }
      video.play().catch(async error => {
        // Audible autoplay may be blocked; silent inline playback remains available.
        if (automatic && error.name === 'NotAllowedError' && mobile.matches &&
            !userPaused && !reducedMotion.matches && !document.hidden) {
          video.muted = true;
          try { await video.play(); } catch { sync(); }
        } else sync();
      });
    };
    button.addEventListener('click', () => {
      userPaused = !video.paused;
      if (video.paused) play();
      else video.pause();
    });
    audioButton?.addEventListener('click', () => {
      video.muted = !video.muted;
      if (!video.muted && video.paused) { userPaused = false; play(); }
      sync();
    });
    video.addEventListener('volumechange', sync);
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) video.pause(); });
    const updateViewport = () => {
      button.hidden = !mobile.matches;
      if (audioButton) audioButton.hidden = !mobile.matches;
      if (!mobile.matches) {
        video.pause();
        if (loaded) {
          video.querySelectorAll('source[data-src]').forEach(source => source.removeAttribute('src'));
          video.load();
          loaded = false;
        }
      } else if (!userPaused && !reducedMotion.matches && !navigator.connection?.saveData) play(true);
    };
    mobile.addEventListener('change', updateViewport);
    updateViewport();
    sync();
  });
})();
